import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';

type ContentGraphicsProps = ComponentProps<'div'>;

/**
 * A component that displays content wrapped into a styled container.<br />
 * Component is responsive and will take full width of its parent.<br />
 * Component has consistent style, including a rounded border, a shadow and a default background color.<br />
 *
 * ```tsx
 * <ContentGraphics>
 *   <div>Content</div>
 * </ContentGraphics>
 * ```
 * @param {ContentGraphicsProps} props - The props for the ContentGraphics component.
 * @param {React.ReactNode} children - The children to be displayed inside the ContentGraphics component.
 * @param {string} className - Optional className to be applied to the ContentGraphics component.
 * @returns {JSX.Element} The ContentGraphics component.
 */
function ContentGraphics({ className, children, ...props }: ContentGraphicsProps) {
  return (
    <div className={twMerge('size-full overflow-hidden rounded-lg bg-secondary border-2 border-border-active shadow-[0_3px_0_0_var(--color-foreground)]', className)} {...props}>
      {children}
    </div>
  );
}

export { ContentGraphics };
